import styles from "../../../../AccountingPage.module.scss";
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from "react";
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { getEmployeeHistoryData } from "service/AccountingService";

const EmployeeHistoryContent = ({ render, setRender, id, dataemployee }) => {
  const { t } = useTranslation('common')

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [datahistory, setDataHistory] = useState([]);
  const getDataHistory = async (id) => {
    try {
      let response = await getEmployeeHistoryData(id);
      setDataHistory(response.data);
    } catch (error) {
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const totalPages = Math.ceil(datahistory.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = datahistory.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    getDataHistory(id);
    setRender(false);
    // eslint-disable-next-line
  }, [render]);

  return (
    <>
      <div className={styles.content_header} style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ width: "100%" }} className={styles.print_header_selection_shah}>
          <h3 className={styles.project__h}>{t('auto.components_employeehistorycontent.k1')}</h3>
          <hr style={{ borderTop: "2px solid #444", margin: "20px 0 0 0" }} />
          <table className={styles.table__wrapper}>
            <thead className={styles.table__head}>
              <tr className={styles.table__row}>
                <th className={styles.table__item_person}>
                  <span className={styles.table__title}>{t('auth.inn')}</span>
                </th>
                <th className={styles.table__item_person}>
                  <span className={styles.table__title}>{t('user.last_name')}</span>
                </th>
                <th className={styles.table__item_person}>
                  <span className={styles.table__title}>{t('user.first_name')}</span>
                </th>
                <th className={styles.table__item_person}>
                  <span className={styles.table__title}>{t('employees.department')}</span>
                </th>
                <th className={styles.table__item_person}>
                  <span className={styles.table__title}>{t('archive.col_position')}</span>
                </th>
                <th className={styles.table__item_person}>
                  <span className={styles.table__title}>{t('employees.rate')}</span>
                </th>
                <th className={styles.table__item_person}>
                  <span className={styles.table__title}>{t('common.status')}</span>
                </th>
                <th className={styles.table__item_person}>
                  <span className={styles.table__title}>{t('distance.datetime_label')}</span>
                </th>
              </tr>
            </thead>
            <tbody className={styles.table__body}>
              <tr className={styles.table__row}>
                <td className={styles.table__item_person}>
                  <span className={styles.table__title}>{dataemployee?.personaldata?.inn}</span>
                </td>
                <td className={styles.table__item_person}>
                  <span className={styles.table__title}>{dataemployee?.personaldata?.surname}</span>
                </td>
                <td className={styles.table__item_person}>
                  <span className={styles.table__title}>{dataemployee?.personaldata?.first_name}</span>
                </td>
                <td className={styles.table__item_person}>
                  <span className={styles.table__title}>{dataemployee.department_name}</span>
                </td>
                <td className={styles.table__item_person}>
                  <span className={styles.table__title}>{dataemployee.posititon_name}</span>
                </td>
                <td className={styles.table__item_person}>
                  <span className={styles.table__title}>{dataemployee.stavka}</span>
                </td>
                <td className={styles.table__item_person}>
                  <span
                    className={styles.table__title}
                    style={{
                      fontWeight: "700",
                      padding: "5px",
                      borderRadius: "6px",
                      display: "block",
                      textAlign: "center",
                      background:
                        dataemployee.status === "Работает"
                          ? "#5C5CFF"
                          : dataemployee.status === "Уволен(а)"
                            ? "#a00000ff"
                            : dataemployee.status === "В отпуске"
                              ? "#ec9900ff"
                              : dataemployee.status === "В командировке"
                                ? "#333333"
                                : dataemployee.status === "На больничном"
                                  ? "#0a62a3"
                                  : dataemployee.status === "В декретном отпуске"
                                    ? "#ffb6c1"
                                    : dataemployee.status === "В отпуске без содержания"
                                      ? "#999"
                                      : "transparent",
                      color: dataemployee.status ? "white" : "inherit",
                    }}
                  >
                    {dataemployee.status || ""}
                  </span>
                </td>
                <td className={styles.table__item_person}>
                  <span className={styles.table__title}>
                    {new Date().toLocaleString("ru-RU", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <h3 className={styles.project__h}>{t('auto.components_employeehistorycontent.k2')}</h3>
          <hr style={{ borderTop: "2px solid #444", margin: "20px 0 0 0" }} />
        </div>

        <table ref={componentRef} className={styles.table__wrapper}>
          <thead className={styles.table__head}>
            <tr className={styles.table__row}>
              <th className={`${styles.table__item_person} ${styles.table__item_number}`}>
                <span className={styles.table__title}>№</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('employees.department')}</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('archive.col_position')}</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('employees.rate')}</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('statements.list.order')}</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('archive.col_period')}</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('common.status')}</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('auto.components_employeehistorycontent.k3')}</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('assignments.description_label')}</span>
              </th>
            </tr>
          </thead>
          <tbody className={styles.table__body}>
            {currentItems.map((item, index) => (
              <tr className={styles.table__row} key={item.id}>
                <td className={styles.table__item_person}>
                  {index + 1 + (currentPage - 1) * itemsPerPage}
                </td>
                <td className={styles.table__item_person}>
                  <span className={styles.table__title} style={{ fontWeight: "700" }}>
                    {item.department_name}
                  </span>
                </td>
                <td className={styles.table__item_person}>
                  <span className={styles.table__title} style={{ fontWeight: "700" }}>
                    {item.posititon_name}
                  </span>
                </td>
                <td className={styles.table__item_person}>
                  <span className={styles.table__title} style={{ fontWeight: "700" }}>
                    {item.stavka}
                  </span>
                </td>
                <td className={styles.table__item_person}>
                  <span className={styles.table__title} style={{ fontWeight: "700" }}>
                    {item.order}
                  </span>
                </td>
                <td className={styles.table__item_person}>
                  <span className={styles.table__title} style={{ fontWeight: "700" }}>
                    {item.date_from || ""} - {item.date_to || ""}
                  </span>
                </td>
                <td className={styles.table__item_person}>
                  <span
                    className={styles.table__title}
                    style={{
                      fontWeight: "700",
                      padding: "5px",
                      borderRadius: "6px",
                      display: "block",
                      textAlign: "center",
                      background:
                        item.status === "Работает"
                          ? "#5C5CFF"
                          : item.status === "Уволен(а)"
                            ? "#a00000ff"
                            : item.status === "В отпуске"
                              ? "#ec9900ff"
                              : item.status === "В командировке"
                                ? "#333333"
                                : item.status === "На больничном"
                                  ? "#0a62a3"
                                  : item.status === "В декретном отпуске"
                                    ? "#ffb6c1"
                                    : item.status === "В отпуске без содержания"
                                      ? "#999"
                                      : "transparent",
                      color: item.status ? "white" : "inherit",
                    }}
                  >
                    {item.status || ""}
                  </span>
                </td>
                <td className={styles.table__item_person}>
                  <span className={styles.table__title} style={{ fontWeight: "700" }}>
                    {item.created_at}
                  </span>
                </td>
                <td className={styles.table__item_person}>
                  <span className={styles.table__title} style={{ fontWeight: "700" }}>
                    {item.description}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
          <div className={styles.pagination}>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                style={{
                  padding: "5px 10px",
                  background: currentPage === page ? "#736CED" : "#f0f0f0",
                  color: currentPage === page ? "#fff" : "#000",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                {page}
              </button>
            ))}
          </div>
        </table>
      </div>
    </>
  );
};

export default EmployeeHistoryContent;